/* ============================================================================
   assets/r24-header.js — ausgelagert aus sections/r24-header-2026.liquid (P2-1, 25.09.2026).
   Ab jetzt ist DIESE Datei die Quelle der Wahrheit; im Liquid steht an der alten
   Stelle nur noch der Skript-Tag (Verweis R24-JS-AUSGELAGERT). Pruefung:
   npm run css:check (audit/perf/extract-css.mjs, Abschnitt "scripts").
   ============================================================================ */
(function () {
  var root = document.getElementById('r24hd');
  if (!root) return;
  /* Touch/Klick-Dropdowns (Hover deckt Desktop ab; hier Tastatur/Touch). */
  root.querySelectorAll('.r24hd-nav__li').forEach(function (li) {
    var a = li.querySelector('.r24hd-nav__a'), sub = li.querySelector('.r24hd-sub');
    if (!sub || !a) return;
    a.addEventListener('click', function (e) {
      /* Nur wenn Kind-Menü existiert und noch nicht offen → erst öffnen, dann folgen */
      if (window.matchMedia('(hover:hover)').matches) return;
      if (!li.classList.contains('is-open')) { e.preventDefault(); root.querySelectorAll('.r24hd-nav__li.is-open').forEach(function(o){ if(o!==li) o.classList.remove('is-open'); }); li.classList.add('is-open'); }
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.r24hd-nav__li')) root.querySelectorAll('.r24hd-nav__li.is-open').forEach(function(o){ o.classList.remove('is-open'); });
  });
  /* Esc schliesst ein offenes Menü und gibt den Fokus an sein Label zurück — vorher blieb
     ein per Tastatur/Touch geöffnetes Panel offen, bis irgendwo anders geklickt wurde. */
  root.addEventListener('keydown', function (e) {
    var li = e.target.closest ? e.target.closest('.r24hd-nav__li') : null;
    if (!li) return;
    if (e.key === 'Escape') {
      clearTimeout(tOpen); clearTimeout(tClose);
      li.classList.remove('is-open');
      li.classList.add('is-esc');
      var a = li.querySelector('.r24hd-nav__a');
      if (a) { try { a.focus(); } catch (err) {} }
    } else {
      li.classList.remove('is-esc');
    }
  });
  /* Esc auch dann, wenn nur die Maus ein Panel geöffnet hat (Fokus steht woanders). */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || (e.target && e.target.closest && e.target.closest('.r24hd-nav__li'))) return;
    clearTimeout(tOpen); clearTimeout(tClose);
    var any = false;
    root.querySelectorAll('.r24hd-nav__li.is-open').forEach(function (o) { o.classList.remove('is-open'); any = true; });
    if (any) syncNav();
  });
  root.addEventListener('focusout', function (e) {
    var li = e.target.closest ? e.target.closest('.r24hd-nav__li') : null;
    if (li) setTimeout(function () { if (!li.contains(document.activeElement)) li.classList.remove('is-esc'); syncNav(); }, 0);
  });

  /* aria-expanded folgt dem ECHTEN Offen-Zustand des Panels. Vorher stand nur
     aria-haspopup="true" (kündigt ein role=menu an, das es nicht gibt) und kein Zustand —
     Screenreader erfuhren nie, ob das Panel offen ist. Offen = Tipp-Öffnen (.is-open),
     Maus darüber oder Tastaturfokus darin (ohne Esc) — genau die CSS-Bedingungen oben. */
  var navLis = [].filter.call(root.querySelectorAll('.r24hd-nav__li'), function (li) {
    var a = li.querySelector('.r24hd-nav__a');
    return a && a.hasAttribute('aria-expanded');
  });
  function syncNav(hoverLi, hoverOn) {
    navLis.forEach(function (li) {
      var open = li.classList.contains('is-open') ||
        (!hi && (li === hoverLi ? hoverOn : li.matches(':hover'))) ||
        (li.matches(':focus-within') && !li.classList.contains('is-esc'));
      var a = li.querySelector('.r24hd-nav__a');
      var v = open ? 'true' : 'false';
      if (a.getAttribute('aria-expanded') !== v) a.setAttribute('aria-expanded', v);
    });
  }
  /* Hover-Absicht (nur echte Maus): 150 ms verweilen öffnet, 250 ms Nachlauf schliesst.
     Steht schon ein Panel offen, wechselt das Überfahren eines Nachbarn sofort — sonst
     flackerte beim Weiterwandern kurz die leere Leiste. Ohne feinen Zeiger (Touch) oder
     ohne JavaScript gelten die bisherigen Wege (Tipp öffnet / CSS-:hover). */
  var HI = window.matchMedia ? window.matchMedia('(hover:hover) and (pointer:fine)') : null;
  var OPEN_MS = 150, CLOSE_MS = 250, tOpen = 0, tClose = 0, hi = false;
  var navEl = root.querySelector('.r24hd-nav');
  function syncHi() {
    hi = !!(HI && HI.matches);
    if (navEl) navEl.classList.toggle('is-hi', hi);
  }
  syncHi();
  if (HI) { if (HI.addEventListener) HI.addEventListener('change', syncHi); else if (HI.addListener) HI.addListener(syncHi); }
  function openLi(li) {
    navLis.forEach(function (o) { if (o !== li) o.classList.remove('is-open'); });
    li.classList.add('is-open');
    syncNav();
  }
  navLis.forEach(function (li) {
    li.addEventListener('mouseenter', function () {
      if (!hi) { syncNav(li, true); return; }
      clearTimeout(tOpen); clearTimeout(tClose);
      var other = root.querySelector('.r24hd-nav__li.is-open');
      if (other === li) return;
      if (other) { openLi(li); return; }
      tOpen = setTimeout(function () { openLi(li); }, OPEN_MS);
    });
    li.addEventListener('mouseleave', function () {
      if (!hi) { syncNav(li, false); return; }
      clearTimeout(tOpen);
      clearTimeout(tClose);
      tClose = setTimeout(function () { li.classList.remove('is-open'); syncNav(); }, CLOSE_MS);
    });
  });
  root.addEventListener('focusin', function () { syncNav(); });
  root.addEventListener('keyup', function () { syncNav(); });   /* Esc schliesst, jede andere Taste hebt is-esc auf */
  document.addEventListener('click', function () { setTimeout(syncNav, 0); });

  /* Scroll-Kondensierung (Handoff): der Header bleibt gepinnt & sichtbar — beim
     Runterscrollen kollabiert der Trust-Strip, Hauptzeile + Suchfeld schrumpfen und
     ein Elevation-Schatten erscheint; beim Hochscrollen fährt alles zurück. Alles
     über die Klasse .is-scrolled (CSS-Übergänge, reduced-motion via CSS-Media-Query).
     Hysterese (an >24px, aus <8px) verhindert Flackern nahe der Schwelle; rAF-
     gedrosselt und passiv. --r24hd-offset = aktuelle (kondensierte) Header-Höhe,
     damit seiten-eigene Sticky-Leisten (z. B. Kategorie-Filter) sauber nachrücken. */
  var sticky = root.querySelector('.r24hd-sticky');
  if (sticky) {
    var scrolled = false, hidden = false, lastY = 0, acc = 0, letztesY = -1;
    var compact = false, cacc = 0, sucheOffen = false;
    var KOMPAKT = window.matchMedia ? window.matchMedia('(max-width:991px)') : null;
    var sopen = root.querySelector('[data-r24hd-sopen]');
    var msuche = root.querySelector('.r24hd-msearch');
    var spacer = root.querySelector('[data-r24hd-spacer]');
    function publishOffset() {
      document.documentElement.style.setProperty('--r24hd-offset', sticky.offsetHeight + 'px');
    }
    /* Platzhalterhöhe = Kopfhöhe im UNKONDENSIERTEN Zustand. Nur bei Start und
       Größenänderung messen — niemals beim Scrollen, sonst wäre die Rückkopplung
       wieder da. Zum Messen werden die Zustandsklassen kurz und ohne Übergang
       entfernt; das passiert innerhalb eines Frames und ist nicht sichtbar. */
    function measureSpacer() {
      if (!spacer) return;
      var warScrolled = sticky.classList.contains('is-scrolled');
      var warHidden = sticky.classList.contains('is-hidden');
      var warCompact = sticky.classList.contains('is-compact');
      var vorher = sticky.style.transition;
      sticky.style.transition = 'none';
      sticky.classList.remove('is-scrolled', 'is-hidden', 'is-compact');
      var h = sticky.offsetHeight;
      if (warScrolled) sticky.classList.add('is-scrolled');
      if (warHidden) sticky.classList.add('is-hidden');
      if (warCompact) sticky.classList.add('is-compact');
      void sticky.offsetHeight;
      sticky.style.transition = vorher;
      if (h > 0) {
        spacer.style.height = h + 'px';
        document.documentElement.style.setProperty('--r24hd-spacer', h + 'px');
      }
    }
    function menuOpen() {
      /* Nie ausblenden, wenn Mega-Menü oder Suchvorschläge offen sind. */
      return !!(root.querySelector('.r24hd-nav__li.is-open') || root.querySelector('.r24hd-sd.is-open'));
    }
    /* Kompakter Kopf (≤ 991 px): eigene Richtungs-Summe wie beim Auto-Hide — 16 px am Stück
       abwärts klappt zu, 40 px aufwärts (oder oben, y ≤ 24) klappt auf. Nie zu, solange die
       Suche offen ist (Lupe getippt, Fokus im Feld, Vorschläge offen). */
    function setCompact(on) {
      if (on === compact) return;
      compact = on;
      sticky.classList.toggle('is-compact', on);
      if (sopen) sopen.setAttribute('aria-expanded', on ? 'false' : 'true');
      publishOffset();
    }
    function sucheAktiv() {
      return sucheOffen || menuOpen() || !!(msuche && msuche.contains(document.activeElement));
    }
    function applyCompact(y, dy) {
      if (!KOMPAKT || !KOMPAKT.matches) { cacc = 0; setCompact(false); return; }
      if (y <= 24 || sucheAktiv()) { cacc = 0; setCompact(false); return; }
      if (dy === 0) return;
      if ((dy > 0) !== (cacc > 0)) cacc = 0;
      cacc += dy;
      /* Hochscrollen klappt NICHT mehr auf (voller Kopf ≈ 157 px = ein Fünftel des Handys); voll nur oben
         (y ≤ 24) oder bei offener Suche — die Lupe öffnet sie jederzeit. */
      if (cacc > 16) { setCompact(true); cacc = 0; }
    }
    function applyScroll() {
      var y = Math.max(0, window.pageYOffset || document.documentElement.scrollTop || 0);
      var s = scrolled ? (y > 8) : (y > 24);   /* Hysterese: an >24, aus <8 */
      if (s !== scrolled) { scrolled = s; sticky.classList.toggle('is-scrolled', s); publishOffset(); }
      applyCompact(y, y - lastY);

      /* Auto-Hide über einen RICHTUNGS-Akkumulator statt einer festen Totzone:
         erst nach 64px zusammenhängendem Abwärtsscrollen verschwindet der Kopf,
         nach 40px aufwärts kommt er zurück. Ein Richtungswechsel setzt den Zähler
         zurück. Damit lösen Trackpad-Jitter, Momentum-Wackler oder ein einzelner
         Sprung keinen Zustandswechsel mehr aus — das war die zweite Zitterquelle. */
      var dy = y - lastY;
      lastY = y;
      if (y <= 120 || menuOpen()) {
        acc = 0;
        if (hidden) { hidden = false; sticky.classList.remove('is-hidden'); }
        return;
      }
      if (dy === 0) return;
      if ((dy > 0) !== (acc > 0)) acc = 0;   /* Richtungswechsel */
      acc += dy;
      if (acc > 64) { if (!hidden) { hidden = true; sticky.classList.add('is-hidden'); } acc = 0; }
      else if (acc < -40) { if (hidden) { hidden = false; sticky.classList.remove('is-hidden'); } acc = 0; }
    }
    /* Ereignisgetrieben statt Dauerschleife (A16-15).
       Vorher lief hier eine requestAnimationFrame-Wacht JEDEN Frame auf JEDER Seite,
       lebenslang — auch wenn niemand scrollte. Sie war die Antwort auf zwei echte
       Probleme, die beide erhalten bleiben:
         1. Sperrflag-Hänger (gemessen 22.07.2026): pausiert der Browser rAF im
            Hintergrund, blieb ein gesetztes Flag für immer stehen → Kopf reagierte nie
            wieder. Hier gibt es kein Dauer-Flag: scroll wertet SOFORT aus (Scroll-
            Ereignisse sind frame-getaktet), und visibilitychange setzt die Wacht zurück.
         2. Eingebettete Vorschauen ohne Scroll-Ereignisse: jede Scroll-, Rad-, Wisch-,
            Zeiger- oder Tasten-Eingabe weckt eine KURZE Wacht, die nach RUHE Frames ohne
            Positionsänderung (≈0,5 s) von selbst endet.
       Ergebnis: 0 Frames im Leerlauf statt ~60/s. */
    var RUHE = 30, ruhig = 0, wachId = 0;
    function pruefen() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (y !== letztesY) { letztesY = y; applyScroll(); return true; }
      return false;
    }
    function wacht() {
      wachId = 0;
      if (pruefen()) ruhig = 0; else ruhig++;
      if (ruhig < RUHE) wachId = window.requestAnimationFrame(wacht);
    }
    function wecken() {
      ruhig = 0;
      if (!wachId) wachId = window.requestAnimationFrame(wacht);
    }
    window.addEventListener('scroll', function () { pruefen(); wecken(); }, { passive: true });
    ['wheel', 'touchmove', 'pointerdown', 'keydown'].forEach(function (t) {
      window.addEventListener(t, wecken, { passive: true });
    });
    window.addEventListener('pageshow', function () { letztesY = -1; wecken(); });
    /* Beim Zurückkehren aus dem Hintergrund einmal nachziehen — Höhe kann sich durch
       Zoom oder Drehung geändert haben, und die Position stimmt womöglich nicht mehr.
       Eine im Hintergrund pausierte Wacht wird verworfen und neu geweckt. */
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState !== 'visible') return;
      if (wachId) { window.cancelAnimationFrame(wachId); wachId = 0; }
      letztesY = -1;
      measureSpacer();
      applyScroll();
      publishOffset();
      wecken();
    });
    window.addEventListener('resize', function () { measureSpacer(); publishOffset(); wecken(); }, { passive: true });
    /* Lupe im kompakten Kopf: Suchzeile aufklappen und Fokus hinein (ohne Seitensprung). Sie
       bleibt offen, bis das Feld den Fokus verliert; danach gilt wieder die Scroll-Regel. */
    if (sopen && msuche) {
      if (sopen.setAttribute) sopen.setAttribute('aria-expanded', 'true');
      sopen.addEventListener('click', function () {
        sucheOffen = true;
        cacc = 0;
        setCompact(false);
        var f = msuche.querySelector('input[type="search"]');
        if (f) { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }
      });
      msuche.addEventListener('focusout', function () {
        setTimeout(function () { if (!msuche.contains(document.activeElement)) sucheOffen = false; }, 0);
      });
    }
    /* Höhe erst NACH dem Kondensieren neu veröffentlichen (Trust-Kollaps/Polster). */
    sticky.addEventListener('transitionend', function (e) {
      if (e.propertyName === 'max-height' || e.propertyName === 'padding-top' || e.propertyName === 'padding-bottom') publishOffset();
    });
    measureSpacer();
    pruefen();
    publishOffset();
    wecken();   /* fängt eine Scroll-Wiederherstellung beim Laden ab, endet dann von selbst 
 Nach Webfont-/Bildladen kann die Kopfhöhe noch minimal wachsen. Der Schrifttausch
       (display=swap) kommt meist VOR load — deshalb zusätzlich sofort nach fonts.ready
       nachmessen, sonst hält der Platzhalter bis load die Fallback-Höhe (A16-25). */
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(function () { measureSpacer(); publishOffset(); });
    }
    window.addEventListener('load', function () { measureSpacer(); publishOffset(); }, { once: true });
  }
})();
